import { MarketingBannerVariant } from "@/api/backofficeRest/generated/model"

export const FIELD_MAX_LENGTH = {
  title: 80,
  subtitle: 220,
  buttonText: 40,
  buttonLink: 500,
} as const

export const VARIANT_ORDER: readonly MarketingBannerVariant[] = [
  MarketingBannerVariant.DEFAULT,
  MarketingBannerVariant.PRICE_CHANGE,
  MarketingBannerVariant.PROMOTIONAL,
]

export const VARIANT_TAB_LABELS: Record<MarketingBannerVariant, string> = {
  [MarketingBannerVariant.DEFAULT]: "Normal",
  [MarketingBannerVariant.PRICE_CHANGE]: "Price change",
  [MarketingBannerVariant.PROMOTIONAL]: "Promotion",
}

export const ALWAYS_SHOWN_BANNERS: ReadonlySet<string> = new Set([
  "referFriend",
  "voteForEnergySource",
])

// Removed at cleanup, when these flags fold into `enabled`.
export const FLAG_CONTROLLED_BANNERS: ReadonlySet<string> = new Set([
  "evTariff",
  "evTrad",
  "flexMarketSubscriptionTrial",
  "heatPumps",
  "homeCover",
  "smartChargingWaitlist",
  "joinSoRewarding",
  "switchToFixedSgtr",
])
